// Carrossel de depoimentos REAIS (fonte: src/data/testimonials.ts). Scroll-snap
// horizontal nativo, sem dependência de Swiper — mais leve e funciona bem em mobile.

import { testimonials } from '../../../data/testimonials';

type Depoimento = {
  nome: string;
  cidade: string;
  texto: string;
  cor: string; // hue para o avatar gradient
  inicial: string;
  badge?: string;
};

const DEPOIMENTOS: Depoimento[] = testimonials.map((t) => ({
  nome: t.name,
  cidade: t.context,
  texto: t.text,
  cor: t.hue,
  inicial: t.initial,
}));

export default function TestimonialsCarousel() {
  return (
    <section className="mz-tst-wrap" aria-label="Depoimentos">
      <div className="mz-tst-head">
        <span className="mz-tst-head-dash" />
        <span className="mz-tst-head-text">famílias que receberam</span>
        <span className="mz-tst-head-dash" />
      </div>

      <div className="mz-tst-scroll">
        {DEPOIMENTOS.map((d, i) => (
          <article key={i} className="mz-tst-card" style={{ '--mz-tst-c': d.cor } as React.CSSProperties}>
            <div className="mz-tst-quote-mark" aria-hidden>"</div>
            <p className="mz-tst-text">{d.texto}</p>

            <div className="mz-tst-foot">
              <div className="mz-tst-avatar" aria-hidden>{d.inicial}</div>
              <div>
                <div className="mz-tst-name">{d.nome}</div>
                <div className="mz-tst-cidade">{d.cidade}</div>
              </div>
            </div>

            {d.badge && (
              <div className="mz-tst-badge">
                <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden>
                  <path d="M12 2.25c-2.694 0-3.025.012-4.084.06-1.06.05-1.78.218-2.413.466a4.872 4.872 0 0 0-1.762 1.148 4.872 4.872 0 0 0-1.148 1.762c-.248.633-.417 1.353-.467 2.413C2.013 9.158 2 9.49 2 12.184c0 2.694.013 3.025.06 4.084.05 1.06.22 1.78.467 2.413.255.66.598 1.216 1.148 1.762.546.55 1.103.893 1.762 1.148.633.247 1.353.417 2.413.467 1.06.048 1.39.06 4.084.06 2.694 0 3.025-.012 4.084-.06 1.06-.05 1.78-.22 2.413-.467a4.872 4.872 0 0 0 1.762-1.148 4.872 4.872 0 0 0 1.148-1.762c.247-.633.417-1.353.467-2.413.048-1.06.06-1.39.06-4.084 0-2.694-.012-3.025-.06-4.084-.05-1.06-.22-1.78-.467-2.413a4.872 4.872 0 0 0-1.148-1.762 4.872 4.872 0 0 0-1.762-1.148c-.633-.248-1.353-.417-2.413-.467C15.025 2.263 14.694 2.25 12 2.25Zm0 1.8c2.65 0 2.96.01 4.007.058.967.044 1.493.205 1.843.34.463.18.794.395 1.142.743.348.348.563.679.743 1.142.135.35.296.876.34 1.843.048 1.046.058 1.36.058 4.007 0 2.648-.01 2.96-.058 4.007-.044.967-.205 1.493-.34 1.843a3.072 3.072 0 0 1-.743 1.142 3.072 3.072 0 0 1-1.142.743c-.35.135-.876.296-1.843.34-1.046.048-1.36.058-4.007.058-2.648 0-2.96-.01-4.007-.058-.967-.044-1.493-.205-1.843-.34a3.072 3.072 0 0 1-1.142-.743 3.072 3.072 0 0 1-.743-1.142c-.135-.35-.296-.876-.34-1.843-.048-1.046-.058-1.36-.058-4.007 0-2.648.01-2.96.058-4.007.044-.967.205-1.493.34-1.843.18-.463.395-.794.743-1.142.348-.348.679-.563 1.142-.743.35-.135.876-.296 1.843-.34C9.04 4.06 9.353 4.05 12 4.05Zm0 3.066a5.067 5.067 0 1 0 0 10.135 5.067 5.067 0 0 0 0-10.135Zm0 8.357a3.29 3.29 0 1 1 0-6.58 3.29 3.29 0 0 1 0 6.58Zm6.45-8.557a1.184 1.184 0 1 1-2.368 0 1.184 1.184 0 0 1 2.367 0Z"/>
                </svg>
                {d.badge}
              </div>
            )}
          </article>
        ))}

        {/* Card final: "venha pro time" */}
        <div className="mz-tst-card mz-tst-card-cta">
          <div className="mz-tst-cta-icon" aria-hidden>♥</div>
          <div className="mz-tst-cta-text">
            Sua família aqui em <em>breve</em>?
          </div>
        </div>
      </div>

      <style>{`
        .mz-tst-wrap {
          margin: 0 0 22px;
        }
        .mz-tst-head {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin: 0 16px 14px;
        }
        .mz-tst-head-dash {
          flex: 1;
          max-width: 56px;
          height: 1px;
          background: var(--gold-border);
          opacity: 0.55;
        }
        .mz-tst-head-text {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--amber-deep);
        }

        .mz-tst-scroll {
          display: flex;
          gap: 12px;
          padding: 6px 16px 16px;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          scroll-padding-left: 16px;
          -webkit-overflow-scrolling: touch;
        }
        .mz-tst-scroll::-webkit-scrollbar { display: none; }
        .mz-tst-scroll { scrollbar-width: none; }

        .mz-tst-card {
          position: relative;
          flex: 0 0 78%;
          max-width: 320px;
          min-height: 220px;
          padding: 22px 20px 18px;
          background: #fff;
          border: 1px solid var(--border-soft);
          border-radius: 16px;
          scroll-snap-align: start;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 16px -10px rgba(80,40,10,0.18);
        }
        html[data-theme='dark'] .mz-tst-card {
          background: rgba(255,255,255,0.04);
          border-color: rgba(255,255,255,0.08);
        }

        .mz-tst-quote-mark {
          position: absolute;
          top: 10px;
          right: 16px;
          font-family: 'Playfair Display', 'Source Serif 4', serif;
          font-style: italic;
          font-weight: 700;
          font-size: 60px;
          line-height: 1;
          color: var(--mz-tst-c, var(--gold));
          opacity: 0.22;
        }

        .mz-tst-text {
          font-family: 'Source Serif 4', 'Playfair Display', serif;
          font-size: 15.5px;
          line-height: 1.55;
          color: var(--text-body);
          margin: 0 0 18px;
          flex: 1;
        }

        .mz-tst-foot {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .mz-tst-avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--mz-tst-c, var(--gold)) 0%, var(--amber-deep) 100%);
          color: #fff;
          font-family: 'Playfair Display', serif;
          font-style: italic;
          font-weight: 800;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 2px 8px rgba(204,102,32,0.32);
        }
        .mz-tst-name {
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 700;
          color: var(--text-strong);
          line-height: 1.2;
        }
        .mz-tst-cidade {
          font-family: 'DM Sans', sans-serif;
          font-size: 11.5px;
          color: var(--text-muted);
          margin-top: 2px;
        }

        .mz-tst-badge {
          margin-top: 12px;
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 4px 10px;
          background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
          color: #fff;
          font-family: 'DM Sans', sans-serif;
          font-size: 10.5px;
          font-weight: 700;
          letter-spacing: 0.04em;
          border-radius: 999px;
          align-self: flex-start;
        }

        .mz-tst-card-cta {
          background: var(--gold-pale);
          border: 1.5px dashed var(--gold-border);
          align-items: center;
          justify-content: center;
          text-align: center;
          flex: 0 0 50%;
          min-width: 200px;
          min-height: unset;
          padding: 24px 20px;
        }
        .mz-tst-cta-icon {
          font-size: 32px;
          color: var(--gold);
          margin-bottom: 8px;
          line-height: 1;
        }
        .mz-tst-cta-text {
          font-family: 'Playfair Display', 'Source Serif 4', serif;
          font-style: italic;
          font-weight: 600;
          font-size: 15px;
          color: var(--amber-deep);
          line-height: 1.3;
        }
        .mz-tst-cta-text em {
          font-style: italic;
          color: var(--gold);
          text-decoration: underline;
          text-decoration-color: var(--gold-border);
          text-underline-offset: 3px;
        }

        @media (min-width: 720px) {
          .mz-tst-scroll { max-width: 720px; margin: 0 auto; padding: 6px 30px 16px; }
          .mz-tst-card { flex: 0 0 45%; }
          .mz-tst-card-cta { flex: 0 0 30%; }
        }
      `}</style>
    </section>
  );
}
